import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=545bdcd7&"
import script from "./Timeline.vue?vue&type=script&lang=js&"
export * from "./Timeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports